export default {
  ACCOUNT: '/teslaaccount',
  ADD_CAR: '/add-car',
  ADD_CAR_SUCCESS: '/add-car/success',
  CONFIRMATION_EMAIL: '/remove-car/confirmation-email',
  CONTACT_SUPPORT: '/support/contact',
  FACTORY_RESET: '/remove-car/factory-reset',
  INSTANT_TRANSFER: '/add-car/instant-transfer',
  LEARN_MORE: '/support/account-support?redirect=no#ownership-transfers',
  NEW_OWNER_INFORMATION: '/remove-car/new-owner-information',
  REMOVE_CAR_ERROR: '/remove-car/error',
  REMOVE_CAR_SUCCESS: '/remove-car/success',
  RENAME_CAR: '/add-car/rename-car',
  SETUP_CHARGING: '/add-car/setup-charging',
  SUBMIT_TRANSFER: '/remove-car/submit-transfer',
  SUPPORT_LINK: '/support/account-support?redirect=no#preferences',
  UPLOAD_DOCUMENTS: '/add-car/upload-documents',
};
